import { QueryClient } from "@tanstack/react-query";

const coreQueryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 1000 * 60 * 5, // 5 minutes
            gcTime: 1000 * 60 * 15, // 15 minutes
            refetchOnWindowFocus: false
        }
    }
});

export default coreQueryClient;
